import React, { Component } from 'react';
import Text from './Text';
import SVB from '../images/Full_pred_vs_BuyNHold.png';
import SVBN from '../images/St_VS_BnH_N.png';
import SVBP from '../images/St_VS_BnH_P.png';
import SVBV from '../images/St_VS_BnH_V.png';
import OOC from '../images/ooc_no_zoom.png';
import OOCP from '../images/OOC_VS_BnH_P.png';
import SVBVV from '../images/predvol_no_zoom.png';
import OOCVV from '../images/oocvol_no_zoom.png';
import CONF from '../images/confidence_lines.png';
import CONFZ from '../images/confidence_lines_zoom.png';
import { NavLink } from 'react-router-dom';

const publicPath = "/";

const StrategyDescription = <div id="Descript">

Welcome to part 4!<br/><br/>

Trading is all about finding out when to buy and when to sell assets, so we need to use the next-day-predictor to take decisions.
When buying and selling we need to know how much of the asset we have and how much cash available for buying assets we have.
We will also keep track of the price and the model's predictions.<br/><br/>

What can we do with the price and next-day predictions to take decisions? Here’s a short list of strategies:<br/>
- Buy if tomorrow's prediction is higher than today’s prediction and sell if vice-versa.<br/>
- Buy if tomorrow's prediction is higher by certain percentage than today’s prediction and sell if vice-versa.<br/>
- Buy if the model predicted a higher price, but the final priced ended being lower and sell if viceversa.<br/>
- Buy if the price has been rising for 3 consecutive days and the model predicts a higher price and sell if viceversa<br/><br/>

And any other strategy that you come up with. Now we have to test the strategy.
In finance the usual way to test a strategy is to see how good (or bad) it performs vs a benchmark that in this case will be buy and hold.
The buy and hold strategy will be to start with 5 bitcoins, so at the end of the exercise we end with 5 bitcoins.
If the strategy is better than buy and hold, we should end with more than 5 bitcoins, or 5 bitcoins and more cash.<br/><br/>

First we are going to make a copy of the last 500 rows of the dataframe called dff and test all of the strategies there.<br/><br/>

<code>
dff = df[-500:]
</code>
<br/><br/>

Now comes the function where we'll write the strategy and the columns that will be uede later for visualization.
I'm going to test two strategies, the first one is: Buy if tomorrow's prediction is higher by certain percentage than today’s prediction and sell if vice-versa.<br/><br/>

Deciding how much you are going to buy or sell each time is also part of the strategy.
Every day you have to sell, you could sell all your bitcoins for cash, or you could sell only 1 bitcoin, or the equivalent in bitcoin of 10% of your portfolio, etc…
To make things simpler I will buy or sell max 1 bitcoin per day. If I don't have enough cash to buy one bitcoin, I’ll buy a fraction.
If I don’t have enough bitcoins to sell 1, I’ll sell a fraction.
In finance, buying and selling in steps is called dollar averaging,
it usually means lower returns but also lower risk since you won’t risk your entire portfolio with a bad decision in a single day.
Now let’s write the strategy and test it. We will call the function for this strategy: "full_pred".<br/><br/>

<code>
def full_pred(x, y):<br/>
&nbsp;&nbsp;&nbsp;&nbsp;btc = [5.0] + [np.nan] * (len(dff)-1)<br/>
&nbsp;&nbsp;&nbsp;&nbsp;cash = [0] + [np.nan] * (len(dff)-1)<br/>
&nbsp;&nbsp;&nbsp;&nbsp;prediction = list(dff['Predictions'])<br/>
&nbsp;&nbsp;&nbsp;&nbsp;price = list(dff['Price'])<br/>
&nbsp;&nbsp;&nbsp;&nbsp;for i in range(1, len(dff)-1):<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;for j in range(0, 2):<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if prediction[i+1] > (prediction[i] * (1.0 + y/100.0)):<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if cash[i] > price[i]:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i-1] + 1.0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i-1] - price[i]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;elif price[i] > cash[i-1] > 0.0:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i-1] + (cash[i-1] / price[i])<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = 0.0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;else:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i - 1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i - 1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;elif (prediction[i] * (1.0 - x/100.0)) > prediction[i+1]:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if btc[i-1] >= 1.0:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i-1] - 1.0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i-1] + price[i]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;elif 1.0 > btc[i-1] > 0.0:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = 0.0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i-1] + (price[i] * btc[i-1])<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;else:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i - 1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i - 1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;else:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i-1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i-1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['BTC'] = btc<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['Cash'] = cash<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['Strategy'] = dff['Price'] * dff['BTC'] + dff['Cash']<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['BuyNHold'] = 5.0 * dff['Price']<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['St_VS_BnH_N'] = dff['Strategy'] - dff['BuyNHold']<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['St_VS_BnH_P'] = ((dff['Strategy'] - dff['BuyNHold']) / dff['BuyNHold']) * 100.0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['BnH_Vol'] = (dff['BuyNHold'].pct_change() * 100.0).rolling(30).std(ddof=0)<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['Strategy_Vol'] = (dff['Strategy'].pct_change() * 100.0).rolling(30).std(ddof=0)<br/>
&nbsp;&nbsp;&nbsp;&nbsp;print "Strategy vs BuyNHold:", (dff['Strategy'][len(dff)-2] - dff['BuyNHold'][len(dff)-2])<br/>
&nbsp;
</code>
<br/><br/>

The first “if” is the case where we buy if the next prediction is way below today's prediction.
The “elif” is the case where we sell if the next prediction is way above today's prediction.
The “else” happens when the next prediction is inside today's prediction boundaries and we do nothing.
The last lines of the function will create new columns in the dataframe dff for visualization.
<br/><br/>

Let's run the function with the following values: 3% for sell and 3% for buy:<br/><br/>

<code>
full_pred(3.0, 3.0)
</code>
<br/><br/>

The function will populate the dataframe dff with all the values we need and then print the balance against Buy and Hold:<br/><br/>

<mark>
Strategy vs BuyNHold: -262.030955012
</mark>
<br/><br/>

To print a chart with the performance of both portfolios:<br/><br/>

<code>
plt.xlabel('Date')<br/>
plt.ylabel('US$')<br/>
plt.plot(dff.index, dff['BuyNHold'])<br/>
plt.plot(dff.index, dff['Strategy'])<br/>
plt.legend(shadow=True, fontsize='large')
</code>
<br/><br/>

<img src={SVB} alt="Pred Vs BuyNHold"/><br/>


We are 200 hundred dollars below Buy and Hold, but the bad news is that the model underperforms Buy and Hold almost everytime, 
let's check the other columns created by the function:<br/><br/>

Strategy vs buy and hold in nominal values.<br/><br/>

<code>
plt.xlabel('Date')<br/>
plt.ylabel('US$')<br/>
plt.plot(dff.index, dff['St_VS_BnH_N'], "b")<br/>
plt.legend(shadow=True, fontsize='large')
</code>
<br/><br/>

<img src={SVBN} alt="Pred Vs BuyNHold N"/>
<br/>

Strategy vs buy and hold in % values.<br/><br/>

<code>
plt.xlabel('Date')<br/>
plt.ylabel('%')<br/>
plt.plot(dff.index, dff['St_VS_BnH_P'], "b")<br/>
plt.legend(shadow=True, fontsize='large')
</code>
<br/><br/>

<img src={SVBP} alt="Pred Vs BuyNHold P"/>
<br/>

Compare the 30 day volatility of both portfolios.<br/><br/>
<code>
plt.xlabel('Date')<br/>
plt.ylabel('Volatility of Portfolio')<br/>
plt.plot(dff.index, dff['BnH_Vol'], "b")<br/>
plt.plot(dff.index, dff['Strategy_Vol'], "r")<br/>
plt.legend(shadow=True, fontsize='large')
</code>
<br/><br/>

<img src={SVBV} alt="Pred Vs BuyNHold V"/>
<br/>

The only good news is that the volatility of the portfolio is lower than buy and hold. This strategy basically misses the bull market of 2017 and the gap closes when the price falls in early 2018.
<br/><br/>

Now let's try the second strategy: If the resulting price is certain percentage above the prediction, sell;
if it is certain percentage lower than the prediction, buy. If it is between the boundaries, do nothing.<br/><br/>

The function is the same as before but we will change a few things, the most important lines are the ones that describe the strategy:<br/><br/>

The old buy strategy was:<br/><br/>
<code>
if prediction[i+1] > (prediction[i] * (1.0 + y/100.0)):
</code>
<br/><br/>

And now:<br/><br/>
<code>
if (prediction[i] * (1.0 - (y/100.0))) > price[i]:
</code>
<br/><br/>

The old sell strategy was:<br/><br/>
<code>
elif (prediction[i] * (1.0 - x/100.0)) > prediction[i+1]:
</code>
<br/><br/>

And now:<br/><br/>
<code>
elif price[i] > (prediction[i] * (1.0 + (x/100.0))):
</code>
<br/><br/>

Here's the full function, called "out_of_conf" for out of confidence levels:<br/><br/>

<code>
def out_of_conf(x, y):<br/>
&nbsp;&nbsp;&nbsp;&nbsp;btc = [5.0] + [np.nan] * (len(dff)-1)<br/>
&nbsp;&nbsp;&nbsp;&nbsp;cash = [0] + [np.nan] * (len(dff)-1)<br/>
&nbsp;&nbsp;&nbsp;&nbsp;prediction = list(dff['Predictions'])<br/>
&nbsp;&nbsp;&nbsp;&nbsp;price = list(dff['Price'])<br/>
&nbsp;&nbsp;&nbsp;&nbsp;for i in range(1, len(dff)):<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;for j in range(0, 2):<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if (prediction[i] * (1.0 - (y/100.0))) > price[i]:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if cash[i-1] > price[i]:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i-1] + 1<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i-1] - price[i]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;elif price[i] > cash[i-1] > 0.0:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i-1] + (cash[i-1] / price[i])<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = 0.0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;else:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i - 1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i - 1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;elif price[i] > (prediction[i] * (1.0 + (x/100.0))):<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if btc[i-1] >= 1.0:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i-1] - 1<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i-1] + price[i]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;elif 1.0 > btc[i-1] > 0.0:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = 0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i-1] + (price[i] * btc[i-1])<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;else:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i - 1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i - 1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;else:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;btc[i] = btc[i-1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cash[i] = cash[i-1]<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['BTC'] = btc<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['Cash'] = cash<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['Strategy'] = dff['Price'] * dff['BTC'] + dff['Cash']<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['BuyNHold'] = 5.0 * dff['Price']<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['St_VS_BnH_N'] = dff['Strategy'] - dff['BuyNHold']<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['St_VS_BnH_P'] = ((dff['Strategy'] - dff['BuyNHold']) / dff['BuyNHold']) * 100.0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['BnH_Vol'] = (dff['BuyNHold'].pct_change() * 100.0).rolling(30).std(ddof=0)<br/>
&nbsp;&nbsp;&nbsp;&nbsp;dff['Strategy_Vol'] = (dff['Strategy'].pct_change() * 100.0).rolling(30).std(ddof=0)<br/>
&nbsp;&nbsp;&nbsp;&nbsp;print "Strategy vs BuyNHold:", (dff['Strategy'][len(dff)-1] - dff['BuyNHold'][len(dff)-1])<br/>
&nbsp;<br/>
</code>
<br/>

After the new function is ready, let's run it with the same parameters as before: 3% for buy and for sell.<br/><br/>

<code>
out_of_conf(3.0, 3.0)
</code>
<br/><br/>

<mark>
Strategy vs BuyNHold: 24443.5583781
</mark>
<br/><br/>

This time we are 24 thousand above Buy and Hold, to print a chart with the performance of both portfolios:<br/><br/>

<code>
plt.xlabel('Date')<br/>
plt.ylabel('US$')<br/>
plt.plot(dff.index, dff['BuyNHold'])<br/>
plt.plot(dff.index, dff['Strategy'])<br/>
plt.legend(shadow=True, fontsize='large')
</code>
<br/><br/>

<img src={OOC} alt="OOC Vs BuyNHold V"/>
<br/>

Let's check the performance in % values.<br/><br/>

<code>
plt.xlabel('Date')<br/>
plt.ylabel('%')<br/>
plt.plot(dff.index, dff['St_VS_BnH_P'], "b")<br/>
plt.legend(shadow=True, fontsize='large')
</code>
<br/><br/>

<img src={OOCP} alt="Pred Vs BuyNHold P"/>
<br/>

This time we perform better than Buy and Hold at the beggining,
then underperform a lot when the bitcoin price starts going up too fast and finally perform way better during the rest of 2018.
<br/><br/>

One tool we can use for visualization is the confidence lines. Let's plot predictions with a confidence value of 3% (same used for trading) and see the results,
if the price is above those lines, that is a sell signal and viceversa with the current strategy.<br/><br/>

<code>
plt.xlabel('Date')<br/>
plt.ylabel('US$')<br/>
plt.plot(dff.index, dff['Price'], color="red")<br/>
plt.plot(dff.index, dff['Predictions'], color="b", alpha=0.1)<br/>
plt.fill_between(dff.index, dff['Predictions']*1.03, dff['Predictions']*0.97, color='b', alpha=0.3)<br/>
plt.legend(shadow=True, fontsize='large')
</code>
<br/><br/>

<img src={CONF} alt="Confidence Lines"/>
<br/>

After zooming in:<br/><br/>

<img src={CONFZ} alt="Confidence Lines Zoom"/>
<br/>

Looking at the zoomed chart, we can see that many times when the price is outside the confidence lines, it is about to rebound or dive,
that's why the strategy has good profits during this period.<br/><br/>

One aspect we should address is that the parameters of the function are fixed, 3% in both cases for buy and sell;
that means we will trade a lot in high volatility periods and nothing at all during low volatility periods.<br/><br/>

We could add volatility to the parameters, that means they will change with lower or higher volatility.
Let's create two functions using the ones we had before, copying everything, changing the names to "full_pred_vol" and "out_of_conf_vol",
replacing the "x" and "y" inside the function for "(vol[i]+x)" "(vol[i]+y)" and adding this list at the beggining:<br/><br/>

<code>
vol = list(dff['Vol'])
</code>
<br/><br/>

For the full code of the new functions you can check my <a href="https://github.com/JRachadell/Bitcoin_Deep_Learning">github</a>.<br/><br/>

Running full_pred_vol(1.0, 1.0) and its respective chart will print us:<br/><br/>

<mark>
Strategy vs BuyNHold: -11187.9479269
</mark>
<br/><br/>

<img src={SVBVV} alt="Pred Vs BuyNHold V"/>
<br/>

Now out_of_conf_vol(1.0, 1.0) and its chart.<br/><br/>

<mark>
Strategy vs BuyNHold: 22517.2611879
</mark>
<br/><br/>

<img src={OOCVV} alt="Pred Vs BuyNHold V"/>
<br/>

full_pred_vol had a poor performance compared to full_pred and out_of_conf_vol's performance was pretty similar to out_of_conf.
You can run the prior blocks of code to check other aspects of the strategies like peformance vs buy and hold in nominal terms or compare volatilities.
<br/><br/>
There is a lot of room for improvement and many ways to make the strategies more profitable, for example:<br/>
- Different neural network architectures, more layers, different timeframes (hourly, weekly), custom loss functions.<br/>
- Not holding cash but using the cash to buy a financial index or a bond while we wait to buy bitcoins again.<br/>
- Adding more variables to predict the price like number of transactions, the hash rate or past volatility.<br/>
- Taking short positions if not holding any bitcoin and there is a sell signal or using leverage to buy if we don’t have enough cash.<br/>
- And many more!<br/><br/>

If you made it this far, congratulations! Neural networks and trading are not easy tasks to explain so I hope you understood everything so far.<br/><br/>

This exercise is for academic purposes, but if you really want to follow a trading strategy based on the information of this post you should read the following.<br/>
1. Past performance does not guarantee future results. Never. Don’t forget this. No index, fund, strategy or person can.<br/>
2. Neural networks are not easy to understand, if you want to create a real trading strategy around this concept, you should fully understand them first.<br/>
3. This part does not take into account trading costs like fees and slippage.<br/>
4. Neural networks usually need to be retrained to learn from new observations, for example every day or every week, etc…<br/>
5. When backtesting the strategy we have a look-ahead bias because the model has already seen all of the data to make predictions.
Using neural networks this could be a problem depending on the number of total observations and past scenarios that the model has already seen
(bull/bear markets, flash crashes, etc…).
This could be fixed by retraining the model for every day in the past but for this academic case it wouldn’t be computationally feasible.
Check the next parts of out tutorial to see performances without look-ahead bias.<br/>
6. Neural networks are referred as “black boxes” because usually we don’t know what’s happening “under the hood”,
that means we don’t know why did the model predict certain value on a certain date.<br/>
7. Neural networks are prone to overfiting, that means it could make odd predictions when facing scenarios very different to what it has seen before.
In the case of bitcoin, it has seen strong bull and bear markets, high volatility periods, stable periods and flash crashes,
but new or more extreme scenarios can’t be ruled out and we don’t know how would the model behave.<br/>
8. Trying to optimize parameters of the trading strategy can also lead to overfitting.
Parameters that fit extremely well using past data will probably perform poorly when facing new data.<br/>
9. It is usually better to use round numbers like 3% or 5% when backtesting. If the strategy needs rules like “buy only if the prediction is 13.45196% higher” to be profitable,
most likely it won’t work in other scenarios.<br/>

10. It is always necessary to make a full risk analysis of the strategy before implementing it. For example:<br/>
&nbsp;&nbsp;- Does the strategy ever goes into negative territory and why?<br/>
&nbsp;&nbsp;- When and why were the most extreme movements in the portfolio?<br/>
&nbsp;&nbsp;- What would the performance be using data of a fictional scenario (a extreme bear market)?<br/>
&nbsp;&nbsp;- Are there extreme deviations in the portfolio compared to a buy and hold strategy, why?<br/>
&nbsp;&nbsp;- Common financial risk measures like VaR, Conditional VaR, tail risk, etc…<br/><br/>

If you want to see new data transformations and different strategies check <NavLink to={`${publicPath}transformations`}>Part 5: Data Transformations and New Strategy</NavLink>.

</div>;

class Strategy extends Component {


  componentDidMount() {
    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
            document.getElementById("myBtn").style.display = "block";
        } else {
            document.getElementById("myBtn").style.display = "none";
        }
    }

    function findPos(obj) {
      var curtop = 0;
      if (obj.offsetParent) {
        while (obj = obj.offsetParent) {
          curtop += obj.offsetTop;
        };
        return [curtop];
      }
    }

    document.getElementById("myBtn").onclick = function() {
      const   scrollHeight = window.scrollY,
              scrollStep = Math.PI / ( 1000 / 15 ),
              cosParameter = scrollHeight / 2;
      var     scrollCount = 0,
              scrollMargin,
              scrollInterval = setInterval( function() {
                  if ( window.scrollY > 10 ) {
                      scrollCount = scrollCount + 1;  
                      scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
                      window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
                  } 
                  else clearInterval(scrollInterval); 
              }, 15 );
    }

    const scrollHeight = window.scrollY - findPos(document.getElementById("myNavbar"))[0],
    scrollStep = Math.PI / ( 1000 / 15 ),
    cosParameter = scrollHeight / 2;
    var scrollCount = 0,
    scrollMargin,
    scrollInterval = setInterval( function() {
        if ( window.scrollY - findPos(document.getElementById("myNavbar"))[0] > 10 ) {
            scrollCount = scrollCount + 1;  
            scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
            window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
        } 
        else clearInterval(scrollInterval); 
    }, 15 );
  }

  render() {
    return (
        <div id="Data">
        <h1>Part 4: First Trading Strategies </h1>
          <Text Searchable="Time" description={StrategyDescription}/>
        </div>
    );
  }
}

export default Strategy;



// WEBPACK FOOTER //
// ./src/components/Strategy.js